// Gemeinsame Strings, die in mehr als einem Bereich vorkommen (Modal-Knöpfe,
// generische Aktionen). Alles, was nur EIN Bereich braucht, gehört in dessen
// eigenen Namespace — sonst wird `common` der Monolith, den die Aufteilung in
// Namespace-Dateien gerade verhindern soll.
//
// KONVENTIONEN (gelten für JEDE Katalog-Datei, Volltext in docs/i18n.md):
//  - Die Keys sind DEUTSCH benannt (`abbrechen`, nicht `cancel`): deutsch ist
//    die Quellsprache, und ein englischer Key wäre schon die erste Übersetzung.
//  - KEIN `as const`. Mit `as const` wären die deutschen Strings Literal-Typen
//    und jede englische Übersetzung ein Typfehler — die Paritätsprüfung würde
//    sich gegen die Übersetzung selbst richten.
//  - Interpolation und Plural sind FUNKTIONEN (siehe tasks.ts), keine
//    Platzhalter-Strings: dann prüft der Compiler die Argumente mit.
// AUFNAHME-KRITERIUM (nach der Konsolidierung 2026-08-19): ein String gehört
// hierher, wenn er in MEHREREN Bereichen vorkommt UND kontextfrei ist — eine
// generische Aktion oder Rückmeldung, die ohne ihre Umgebung dasselbe bedeutet
// und deshalb in jeder Sprache dieselbe Übersetzung hat. Gegenprobe vor dem
// Verschieben: haben ALLE Fundstellen denselben englischen Text? Wenn nicht
// („Löschen" → „Delete" vs. „Delete draft"), ist es kein Duplikat, sondern
// zufällige Gleichheit — dann bleibt der String im Bereichs-Namespace.
// Substantive/Feldnamen bleiben grundsätzlich draußen: „Titel" ist im
// Aufgaben-Formular „Title" und in den Quellen-Optionen „Titles".
export const common = {
  abbrechen: "Abbrechen",
  bestaetigen: "Bestätigen",
  schliessen: "Schließen",
  speichern: "Speichern",
  loeschen: "Löschen",
  bearbeiten: "Bearbeiten",
  anlegen: "Anlegen",
  verwerfen: "Verwerfen",
  zurueck: "Zurück",
  aktualisieren: "Aktualisieren",
  herunterladen: "Herunterladen",
  erneutVersuchen: "Erneut versuchen",
  speichernFehlgeschlagen: "Speichern fehlgeschlagen",
};

export type CommonKatalog = typeof common;
